export const ADD_PRODUCT = 'ADD_PRODUCT';
export const SET_PRODUCTS = 'SET_PRODUCTS';
export const RESET_CART = 'RESET_CART';
export const REMOVE_PRODUCT = 'REMOVE_PRODUCT';
export const SET_FLAG = 'SET_FLAG';
